(function () {
	'use strict';

	angular
		.module('wizard-future7.services')
		.service('HelperService', HelperService)

	/** @ngInject */
	function HelperService($timeout, $state, $rootScope, NotifyService, ROUTES) {
		const HelperService = {
			handleOnRun,
			handleStateChangeStart,
			handleStateChangeSuccess,
			handleStateChangeError,
			handleViewContentLoaded,
			tryParseJSON,
			errorCallback,
			successCallback,
			startLoading,
			stopLoading,
			setErrorMessageForm,
			removeErrorMessageForm,
			getValidationMessage,
			convertToSlug,
			isScreenSmaller,
			getFlowOptionsDefaults,
			getFlowOptionsDefaultsGeneral,
			scrollTo,
			skipBanner,
			getArrayByObject,
			getCookie,
			clearLocalStorageData
		};

		return HelperService;

		/**
		 * Auxiliar method executed when the system is starting
		 */
		function handleOnRun() {
			//Comment this to exit errors related to transition and/or transition related services like User or Menu
			// $state.defaultErrorHandler(angular.noop);
			$rootScope.removeMessage = removeErrorMessageForm;

			$rootScope.isMobile = isScreenSmaller(767);

			$rootScope.currentYear = moment().format('YYYY');
		}

		function skipBanner() {
			$(document).ready(function () {
				$('html, body').animate({
					scrollTop: ($('#end-banner').offset().top - ($('.navbar').outerHeight()))
				}, 900);
			});
		}

		/**
		 * Auxiliar method to execute the necessary methods on the route change start
		 * 
		 * @param {object} transition - The executing transition
		 */
		function handleStateChangeStart(transition) {
			const nextUrl = transition.to().url;

			// if (transition.to().name.indexOf('app-auth') >= 0)
			// 	return transition;

			// if (transition.to().name.indexOf('default') >= 0)
			// 	return transition;

			// if (!AuthenticationService.isLogged()) {
			// 	AuthenticationService.logout();
			// 	return false;
			// }

			// if (nextUrl.indexOf('not-authorized') > 0)
			// 	return transition;

			// if (!AuthenticationService.canAccess(transition.to()))
			// 	return transition.router.stateService.transitionTo('default.not-authorized');

			// if (!AuthenticationService.unitHasPermission(transition.from()))
			// 	return false;

			return transition;
		}

		/**
		 * Auxiliar method executed on every route state successfull change
		 */
		function handleStateChangeSuccess() {
			$('.navbar-collapse').collapse('hide');
		}

		/**
		 * Auxiliar method executed when the route change fails
		 *
		 * @param {object} error - The transition error
		 */
		function handleStateChangeError(error) {
			$('.navbar-collapse').collapse('hide');

			if (error && error.redirTo)
				$state.go(error.redirTo);
		}

		/**
         * Auxiliar method executed once the system has finished loading all of it's content
         */
		function handleViewContentLoaded() {
			AOS.init();
		}

        /**
         * Tries to parse a JSON string
         * 
         * @param {string} jsonString - String to be parsed
         */
		function tryParseJSON(jsonString) {
			try {
				var o = JSON.parse(jsonString);

				// Handle non-exception-throwing cases:
				// Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
				// but... JSON.parse(null) returns null, and typeof null === "object",
				// so we must check for that, too. Thankfully, null is falsey, so this suffices:
				if (o && typeof o === 'object')
					return o;
			} catch (e) {
				return false;
			}

			return false;
		}

		function errorCallback(error) {
			let message = 'Ocorreu um erro inesperado, por favor tente novamente.';

			if (error && error.Error && error.Message)
				message = error.Message;

			NotifyService.error('ERRO!', message);
		}

		function successCallback(type = 'create') {
			let message = '';

			if (type == 'create')
				message = 'Registro salvo com sucesso.';

			else if (type == 'update')
				message = 'Registro atualizado com sucesso.';

			else if (type == 'delete')
				message = 'Registro apagado com sucesso.';

			NotifyService.success('SUCESSO!', message);
		}

		function startLoading(element, message = null, isFullScreen = false) {
			$timeout(() => {
				let widget = $(element).closest('[data-widget]');

				if ($(element).attr('[data-widget]'))
					widget = $(element);

				const loadingBody = document.createElement('div');

				if (isFullScreen == true)
					loadingBody.className = 'loading-body full'
				else
					loadingBody.className = 'loading-body';

				const loadingContent = document.createElement('div');
				loadingContent.className = 'loading-content';



				$(loadingContent).append(`<img src="/app/dist/images/loader.svg" alt="Carregando, aguarde..." />`);

				if (message)
					$(loadingContent).append(`<p>${message}</p>`);

				loadingBody.appendChild(loadingContent);

				widget.append(loadingBody);
			})
		}

		function stopLoading(element) {
			$timeout(() => {
				let widget = $(element).closest('[data-widget]');

				if ($(element).attr('[data-widget]'))
					widget = $(element);

				widget
					.find('.loading-body')
					.fadeOut(function () {
						$(this).remove();
					});
			})
		}

		function setErrorMessageForm(input, message) {
			let errorMessage = 'Este campo é obrigatório';

			if (message)
				errorMessage = message;

			if (!$(input).parent().find('.validationMessage').length) {
				$(input).parent()
					.append(`<label class=\'control-label has-error validationMessage\'>${errorMessage}</label>`);

				$(input)
					.addClass('has-error')
					.parents('.form-group')
					.addClass('has-error');
			}

			$([document.documentElement, document.body]).animate({
				scrollTop: $(input).offset().top - ($('.header').outerHeight() + 30)
			}, 600);
		}

		function removeErrorMessageForm(input) {
			$(input)
				.parent()
				.find('.validationMessage')
				.remove();

			$(input)
				.removeClass('has-error')
				.parents('.form-group')
				.removeClass('has-error');
		}

		function getValidationMessage(type) {
			var messages = {
				required: 'Este campo é obrigatório',
				email: 'Por favor, forneça um endereço de email válido',
				date: 'Por favor, forneça uma data válida',
				phone: 'Por favor, forneça um telefone válido',
				number: 'Por favor, forneça um número válido',
				cpf: 'Por favor, forneça um cpf válido',
				cnpj: 'Por favor, forneça um cnpj válido',
				url: 'Por favor, forneça uma url válida',
				name: 'Por favor, forneça um nome válido',
				lastName: 'Por favor, forneça um sobrenome válido',
				passNotMatch: 'As senhas não combinam',
				passTooSmall: 'A senha deve conter ao menos 8 caracteres',
				passNoUpper: 'A senha deve conter ao menos um caracter maiúsculo',
				passNoNumeric: 'A senha deve conter ao menos um caracter numérico'
			};

			return messages[type];
		}

		function convertToSlug(str) {
			const a = 'àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;'
			const b = 'aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------'
			const p = new RegExp(a.split('').join('|'), 'g')

			return str.toString().toLowerCase()
				.replace(/\s+/g, '-') // Replace spaces with -
				.replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
				.replace(/&/g, '-and-') // Replace & with 'and'
				.replace(/[^\w-]+/g, '') // Remove all non-word characters
				.replace(/--+/g, '-') // Replace multiple - with single -
				.replace(/^-+/, '') // Trim - from start of text
				.replace(/-+$/, '') // Trim - from end of text
		}

		function isScreenSmaller(size) {
			return Modernizr.mq(`(max-width: ${size}px)`);
		}

		function getFlowOptionsDefaults() {
			return {
				permanentErrors: [500, 501, 428],
				maxChunkRetries: 1,
				chunkRetryInterval: 5000,
				simultaneousUploads: 1,
				allowDuplicateUploads: false,
				singleFile: true,
				target: `${ROUTES.API}/files/images/upload`,
			}
		}

		function getFlowOptionsDefaultsGeneral() {
			return {
				permanentErrors: [500, 501, 428],
				maxChunkRetries: 1,
				chunkRetryInterval: 5000,
				simultaneousUploads: 1,
				allowDuplicateUploads: false,
				singleFile: true,
				target: `${ROUTES.API}/files/upload`,
			}
		}

		function scrollTo(navTo) {
			$('html, body').animate({
				scrollTop: ($(navTo).offset().top - ($('.navbar').outerHeight()) - 20)
			}, 600);
		}

		function getArrayByObject(object) {
			return Object.entries(object);
		}

		function getCookie(cname) {
			let name = cname + "=";
			let decodedCookie = decodeURIComponent(document.cookie);
			let ca = decodedCookie.split(';');

			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ')
					c = c.substring(1);

				if (c.indexOf(name) == 0)
					return c.substring(name.length, c.length);
			}

			return "";
		}

		function clearLocalStorageData(keyName) {
			if (localStorage.getItem(keyName))
				localStorage.removeItem(keyName)
		}
	}
}());